import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import RegionTable from './table/js/regionTable';
import RegionCreate from './create/js/regionCreate';
import PropTypes from 'prop-types';

function RegionManagement() {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  return (
    <div className="eduss-region-management" style={{ padding: '20px' }}>
      <RegionTable 
        onCreateRegion={() => setShowCreateModal(true)} 
        reloadKey={reloadKey}
      />

      {/* Create Region Modal */}
      {showCreateModal && createPortal(
        <div className="eduss-global-modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="eduss-global-modal large eduss-admin-form-modal" onClick={e => e.stopPropagation()}>
            <div className="eduss-global-modal-header">
              <h3>Create New Region</h3>
              <button onClick={() => setShowCreateModal(false)}>&times;</button>
            </div>
            <div className="eduss-global-modal-content">
              <RegionCreate
                onClose={() => setShowCreateModal(false)}
                onSubmit={() => { setReloadKey(p => p + 1); setShowCreateModal(false); }}
              />
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
}

RegionManagement.propTypes = {
  initialTab: PropTypes.string,
};

export default RegionManagement;
